
const Copyright = (props) => {
    return (
        <div className="copyright text-muted text-xs text-left mt-2">
            {/* © {new Date().getFullYear()}{" "} */}
            Powered by <a
                className="font-weight-bold ml-1"
                href="https://futurehealthintelligence.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                Future Health Intelligence
            </a>
        </div>
    );
};

export default Copyright;